import { useSyncExternalStore } from "react";

// 라우터 트리(src/router.tsx) 밖에서 쓰는 경량 pathname 헬퍼. App.tsx 의 인증/온보딩
// 게이트는 세션 유무에 따라 RouterProvider 자체를 마운트할지 말지 결정하므로,
// 라우트 트리가 없을 때도 동작해야 해서 여기서 따로 pathname 을 구독한다.

export const AUTH_LOGIN_PATH = "/auth/login";
export const AUTH_REGISTER_PATH = "/auth/register";
/** Electron 딥링크 로그인 핸드오프(브라우저 ↔ 앱) 경로. pages/desktop-handoff 참고. */
export const AUTH_LINK_PATH = "/auth/link";
/** 비밀번호 찾기(재설정 메일 요청) 화면. */
export const AUTH_FORGOT_PATH = "/auth/forgot-password";
/** 재설정 메일 링크가 향하는 화면. ?token=... 를 읽어 새 비밀번호를 설정한다. */
export const AUTH_RESET_PATH = "/auth/reset-password";
/** 이메일 인증 안내 화면(인증 메일 재발송 포함). */
export const AUTH_VERIFY_PATH = "/auth/verify-email";
/** 팀 초대 수락 화면. 초대 메일의 링크가 향하는 경로(?id=<invitationId>). 로그인
 * 여부와 무관하게 열 수 있어야 한다 — 로그인 전엔 안내만, 로그인 후 실제 수락. */
export const AUTH_INVITE_PATH = "/invite";
/** 로그인/가입을 마친 뒤 되돌아갈 대기 중인 초대 id 를 저장하는 localStorage 키.
 * pages/invite/Page.tsx 가 쓰고, App.tsx 의 로그인 후 리다이렉트 effect 가 읽는다. */
export const PENDING_INVITATION_KEY = "pendingInvitationId";

/** task 공개 공유 링크 경로 prefix. `/public/tasks/<token>`. 로그인 여부와 무관하게
 * 열려야 해서(비로그인 열람이 목적) App.tsx 가 세션 판정보다 먼저 이 경로를 가로챈다.
 * 서버 wrangler.jsonc 의 run_worker_first 에 `/public/*` 가 없어 SPA 폴백으로 온다. */
export const PUBLIC_TASK_PATH_PREFIX = "/public/tasks/";

/** rate limit(429) 대기 화면 경로. 서버가 요청을 제한하면 세션 조회(get-session)도
 * 429 가 나 App.tsx 게이트가 "세션 없음"으로 오인해 로그인으로 튕겨 버린다 — 그걸
 * 막고, 인증 게이트 바깥의 "아무 백엔드 요청도 안 하는" 이 화면으로 보낸 뒤 몇 초
 * 기다리면 되는지 progress bar 로 안내한다(pages/rate-limited, lib/rateLimitNotice). */
export const RATE_LIMITED_PATH = "/rate-limited";

/** history를 갱신하며 SPA 이동. 같은 경로면 무시. */
export function navigate(path: string) {
  if (window.location.pathname === path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

/** 현재 pathname을 구독. popstate에 반응해 리렌더. */
export function usePathname(): string {
  return useSyncExternalStore(subscribePopState, () => window.location.pathname);
}

function subscribePopState(onChange: () => void) {
  window.addEventListener("popstate", onChange);
  return () => window.removeEventListener("popstate", onChange);
}
